import { Typography } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectSelectedIntrument } from "../../../../slices/SavedInstrumentSlice";
import { selectCurrencyCode } from "../../../../slices/PaymentSessionDetailsSlice";
import TranslateText from "../../../resuableComponents/TranslateText";
import { Table } from "antd";
import CardPaymentForm from "../cardPayment/cardPaymentForm";

export default function EmiPlanDetails({ paymentInfo }) {
  const { t } = useTranslation();
  const selectedInstrument = useSelector((state) => selectSelectedIntrument(state));
  const currencyCode = useSelector((state) => selectCurrencyCode(state));
  const { emiAmountLocaleFull, interestChargedAmountLocaleFull, totalAmountLocaleFull, issuer, merchantBorneInterestAmount, merchantBorneInterestAmountLocaleFull } = selectedInstrument?.emiMethod;

  const TableColumnData = ({ symbol, value, color = null, weight = 400 }) => {
    return (
      <Typography className="domestic-pi-header dynamic-font-family" style={{ color: color, fontSize: '0.7rem' }}>
        <span style={{ fontFamily: 'sans-serif', fontWeight: weight }}>{symbol}</span>
        <span style={{ fontFamily: 'Poppins, sans-serif', fontWeight: weight }}>{value.join('')}</span>
      </Typography>
    )
  }

  const columns = [
    {
      title: <span className="table-header"> {t('EMI/MONTH')} </span>,
      dataIndex: 'emiMonth',
      key: 'emiMonth',
      render: (text) => {
        const [symbol, ...value] = text.split(/(\d+)/);
        return <TableColumnData symbol={symbol} value={value} />;
      },
    },
    {
      title: <span className="table-header"> {t('INTEREST')} </span>,
      dataIndex: 'interest',
      key: 'interest',
      render: (text) => {
        const [symbol, ...value] = text.split(/(\d+)/);
        return <TableColumnData symbol={symbol} value={value} />;
      },
    },
    ...(merchantBorneInterestAmount
      ? [{
        title: <span className="table-header"> {t('DISCOUNT')} </span>,
        dataIndex: 'discount',
        key: 'discount',
        render: (text) => {
          const [symbol, ...value] = text.split(/(\d+)/);
          return <TableColumnData symbol={symbol} value={value} color={'#2DA94F'} />;
        },
      }]
      : []),
    {
      title: <span className="table-header"> {t('TOTAL_COST')} </span>,
      dataIndex: 'totalCost',
      key: 'totalCost',
      render: (text) => {
        const [symbol, ...value] = text.split(/(\d+)/);
        return <TableColumnData symbol={symbol} value={value} weight={600} />;
      },
    },
  ];

  const dataSource = [
    {
      key: '1',
      emiMonth: `${currencyCode}${emiAmountLocaleFull}`,
      interest: `${currencyCode}${interestChargedAmountLocaleFull}`,
      ...(merchantBorneInterestAmount && { discount: `-${currencyCode}${merchantBorneInterestAmountLocaleFull}` }),
      totalCost: `${currencyCode}${totalAmountLocaleFull}`,
    },
  ];

  const AmountComponent = ({ amount, styles }) => {
    return <span style={{ ...styles }}>
      <span
        style={{
          fontFamily: "sans-serif",
        }}
      >
        {currencyCode}{""}
      </span>
      {amount}
    </span>
  }

  return (
    <>
      <Table dataSource={dataSource} columns={columns} pagination={false} className="custom-table" />
      <div>
        <div>
          <div style={{ display: "flex", margin: "8px 0px 12px 0px" }}>
            <Typography className="noteHeading dynamic-font-family">
              <TranslateText label={'CARD_CHARGED_AMOUNT'}>Your card will be charged for an amount of</TranslateText>{" "}
              <AmountComponent amount={selectedInstrument?.emiMethod?.netAmountLocaleFull} styles={{ fontWeight: 700 }} />{" "}

              <TranslateText label={'CHARGED_INTEREST'}>Your card will be charged interest of</TranslateText>{" "}
              <AmountComponent amount={selectedInstrument?.emiMethod?.interestChargedAmountLocaleFull} styles={{ fontWeight: 700 }} />{" "}

              <TranslateText label={'BANK_TOTAL_PAYABLE_AMOUNT'}>by the bank making the total payable amount as</TranslateText>{" "}
              <AmountComponent amount={selectedInstrument?.emiMethod?.totalAmountLocaleFull} styles={{ fontWeight: 700 }} />{" "}
            </Typography>
          </div>

          {selectedInstrument?.emiMethod?.processingFee && (
            <>
              <div style={{ display: "flex", margin: "8px 0px 12px 0px" }}>
                <Typography className="noteHeading dynamic-font-family">
                  <TranslateText label={'PROCESSING_FEE_AMOUNT'}>A processing fee of</TranslateText>{" "}
                  <AmountComponent amount={selectedInstrument?.emiMethod?.processingFee?.amountLocaleFull} styles={{ fontWeight: 700 }} />{" "}
                  <span style={{ fontWeight: 700 }}>
                    + <TranslateText label={'GST'}>GST</TranslateText>
                  </span>{" "}
                  <TranslateText label={'BANK_EMI_TRANSACTION'}>as applicable by the bank on the successful EMI transactions</TranslateText>.
                </Typography>
              </div>
            </>
          )}
        </div>

        <CardPaymentForm
          paymentType="Emi"
          selectedEmiBankTitle={issuer}
          cardType={selectedInstrument?.brand === "DebitCardEMI" ? "DEBIT" : "CREDIT"} />
      </div>
    </>
  );
}
